import { notifications } from "@mantine/notifications";
import { t } from "i18next";

import { useCreatePartToSearch } from "#modules/similarPart/view/useCreatePartToSearch";
import { PartFileButton } from "#shared/view/components/PartFileButton";
import { ProgressBar } from "#shared/view/components/ProgressBar";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { formatFileSize, UPLOAD_CONFIG } from "shared";

export const AssemblyTreeHeader = () => {
  const { isPending, uploadFile, progress, resetProgress } = useCreatePartToSearch();

  const newSearch = async (files: { id?: string; name: string; data: File }[]) => {
    resetProgress();
    if (files.some((f) => f.data.size > UPLOAD_CONFIG.PART.maxFileSize)) {
      notifications.show({
        title: t("similarPart.createPart.error"),
        message: t("common.fileTooLarge.exceedsMaxSize", {
          maxSize: formatFileSize(UPLOAD_CONFIG.PART.maxFileSize),
        }),
        color: "red",
      });
      return;
    }
    await uploadFile(files.map((file) => file.data));
  };

  return (
    <Stack gap={0}>
      {isPending && progress > 0 ? (
        <>
          <Text>Chargement du fichier...</Text>
          <ProgressBar value={progress} label={`${progress} %`} animated={progress < 100} />
        </>
      ) : (
        <PartFileButton
          buttonLabel={t("similarPart.dropzone.new_title")}
          buttonVariant="subtle"
          onChange={newSearch}
        />
      )}
    </Stack>
  );
};
